var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('vue-element-loading',{attrs:{"active":_vm.isActive,"is-full-screen":true,"spinner":"bar-fade-scale","color":"#007bce"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }